import { WHATSAPP_NUMBER } from "@/config/site";
import { getValidVariantCodes } from "@/data/catalog";

export function isWhatsAppConfigured() {
  return (
    typeof WHATSAPP_NUMBER === "string" &&
    /^\d{8,15}$/.test(WHATSAPP_NUMBER.trim())
  );
}

function waUrl(text) {
  if (!isWhatsAppConfigured()) return null;
  return `https://wa.me/${WHATSAPP_NUMBER.trim()}?text=${encodeURIComponent(text)}`;
}

// Generic entry point. WhatsApp bot trigger for stock info. Message is exactly
// the lowercase word "stok" — no greeting, punctuation, or extra words.
export function buildStockWhatsAppUrl() {
  return waUrl("stok");
}

// Selected-purchase trigger. Sends exactly "buy [exactVariantCode]". The code
// MUST exist in the authoritative catalog; otherwise returns null so no invalid
// buy command can ever open WhatsApp.
export function buildBuyWhatsAppUrl(variantCode) {
  if (!variantCode || !getValidVariantCodes().has(variantCode)) return null;
  return waUrl(`buy ${variantCode}`);
}

export function isValidVariantCode(variantCode) {
  return getValidVariantCodes().has(variantCode);
}
